<div class="title" fxLayoutAlign="center center">
    <h4 class="widget-title" [style.font-size]="item.customField39"  [ngStyle.lt-md]="{ 'font-size': item.customField40}" [innerHTML]="item.title"></h4>
</div>
<div>
    <div [attr.data-tf-live]="typeformId"></div>
</div>